const getTargetValue = (value) => {
  value = value?.toLowerCase();
  switch (value) {
    case 'inline':
    case 'self':
    case 'modal':
      return value;
  }
  return null;
};
export default getTargetValue;
